import { useEffect, useState } from "react";
import { Form, Row, Col, Button, Accordion, Modal } from "react-bootstrap";
import "bootstrap-icons/font/bootstrap-icons.css";
import "./NewBookingForm.css"
import { format, parse } from 'date-fns';
import useApp from '../AppContext';
import ListPos from "./ListPos";
import { getCultureInfo } from "../crud/utils";
import DynamicDatePicker from "../Components/DynamicDatePicker";
import { loadListAllObjects, loadFormObject, postBooking, loadEditObject, getBookingSuppliers, getPorders, getBookingTasks, getDropdownLookupList, getSuppliers, loadDataObject } from "./CalendarUtils";
import { getPropValue, setPropValue } from '../crud/utils';
import AutoCompleteOneOutPut from './../crud/AutoCompleteOneOutPut'
import { createGql, callApi } from "../crud/utils";
import ListSuppliers from "./ListSuppliers";
import List3pls from "./List3pls";
import { ErrorAlert } from "../crud/utils";
import { t } from "./../i18n"
import CustomDropdown from "../Components/CustomDropdown";

function NewBookingForm(props) {
    const app = useApp();
    const [serverUrl] = useState(app.serverUrl);
    const [userid] = useState(app.sessionToken?.UserId);
    const [User3plId] = useState(app.sessionToken?.User3pl);
    const [gridTop] = useState(app.gridTop);
    const [language] = useState(getCultureInfo(app.sessionToken?.Language));
    const [role] = useState(app.sessionToken?.Role);
    const [allColumnsObj, setAllColumnsObj] = useState({});
    const [bookingObj, setBookingObj] = useState({})
    const [isBookingSaved, setIsBookingSaved] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isLoadObj, setIsLoadObj] = useState(false);
    const [lookUpInfo, setLookUpInfo] = useState(null);
    const [selectionMethod, setSelectionMethod] = useState(null);
    const [isSuppliersModalOpen, setIsSuppliersModalOpen] = useState(false);
    const [savedSuppliers, setSavedSuppliers] = useState([]);
    const handleOpenSuppliersModal = () => {
        setSavedSuppliers([...(bookingObj["Yms_Suppliers"] || [])]);
        setIsSuppliersModalOpen(true);
    };
    const handleCloseSuppliersModal = () => {
        setBookingObj(prev => ({
            ...prev,
            Yms_Suppliers: [...savedSuppliers]
        }));
        setIsSuppliersModalOpen(false);
    };
    const [is3plsModalOpen, setIs3plsModalOpen] = useState(false);
    const [saved3pls, setSaved3pls] = useState([]);
    const handleOpen3plsModal = () => {
        setSaved3pls([...(bookingObj["Yms_3pls"] || [])]);
        setIs3plsModalOpen(true);
    };
    const handleClose3plsModal = () => {
        setBookingObj(prev => ({
            ...prev,
            Yms_3pls: [...saved3pls]
        }));
        setIs3plsModalOpen(false);
    };
    const [errorMessage, setErrorMessage] = useState(null);
    const [activeAccordionKey, setActiveAccordionKey] = useState(null);

    useEffect(() => {
        const hasPos = bookingObj["Yms_Porders"]?.length > 0;
        const hasSuppliers = bookingObj["Yms_Suppliers"]?.length > 0;

        if (hasPos && !hasSuppliers) {
            setSelectionMethod('pos');
        } else if (hasSuppliers && !hasPos) {
            setSelectionMethod('suppliers');
        } else if (hasPos && hasSuppliers) {
            setSelectionMethod('pos');
        } else {
            setSelectionMethod(null);
        }
    }, [bookingObj]);

    useEffect(() => {
        async function getDefaultLayouts() {
            if (!serverUrl) return;
            if (!allColumnsObj || (Object.keys(allColumnsObj).length === 0)) {
                let allobj = await loadListAllObjects(serverUrl, props.userToken)
                if (allobj) {
                    setAllColumnsObj(allobj);
                    setIsLoadObj(true);
                }
                const layoutBooking = await loadFormObject(serverUrl, props.userToken, "Yms_Booking");
                if (layoutBooking) {
                    const retLookupList = await getDropdownLookupList(serverUrl, props.userToken, layoutBooking);
                    if (retLookupList) {
                        setLookUpInfo(prev => {
                            prev = { ...prev };
                            prev["Yms_Booking"] = retLookupList;
                            return prev;
                        });
                    }
                }
                const layoutBookTasks = await loadFormObject(serverUrl, props.userToken, "Yms_BookingTasks");
                if (layoutBookTasks) {
                    const retLookupList = await getDropdownLookupList(serverUrl, props.userToken, layoutBookTasks);
                    if (retLookupList) {
                        setLookUpInfo(prev => {
                            prev = { ...prev };
                            prev["Yms_BookingTasks"] = retLookupList;
                            return prev;
                        });
                    }
                }
            }
        }
        getDefaultLayouts();
    }, [serverUrl, props.userToken, allColumnsObj]);

    useEffect(() => {
        async function getYmsBooking() {
            if (!props?.bookingId) return;
            const objectName = "Yms_Booking";
            if (Object.keys(allColumnsObj).length === 0) return;
            let defaultVariables = {
                "instanceName": "m_yms_booking",
                "filterName": "customfilter",
                "dontCash": "true"
            }
            let prms = [];
            let prmValues = {};
            if (props.actions === "NewBoocking") {
                defaultVariables["createNewRow"] = "true";
            }
            else {
                defaultVariables["appendFilter"] = "{BookingId} =?(;n;15;p_BookingId) ";
                prms.push({ "parameterName": "p_BookingId", "type": "" });
                prmValues["p_BookingId"] = Number(props.bookingId || 0);
            }
            const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables)
            if (result.data[objectName]) {
                let resultobj = result.data[objectName];
                if (props.actions === "NewBoocking") {
                    const localDate = (props.selectTtimeSlot) ? props.selectTtimeSlot : new Date();
                    const localString = format(localDate, "yyyy-MM-dd'T'HH:mm")
                    resultobj[0]["WarehouseId"] = props.warehouseid
                    //  resultobj[0]["InDate"] = (props.selectTtimeSlot) ? props.selectTtimeSlot : new Date();
                    // resultobj[0]["FromDate"] = (props.selectTtimeSlot) ? props.selectTtimeSlot : new Date();
                    resultobj[0]["InDate"] = localString;
                    resultobj[0]["FromDate"] = localString;
                    resultobj[0]["BookingUserId"] = userid;
                    resultobj[0]["Yms3plId"] = User3plId;
                }
                resultobj[0]["LastUpdateUserId"] = userid;
                let objEdit = {
                    Obj: resultobj[0],
                    rowRestrictions: result.rowRestrictions,
                    disabledFields: result.disabledFields
                }
                const resYmsBsu = await getBookingSuppliers(serverUrl, props.userToken, allColumnsObj, objEdit.Obj.BookingId);
                if (resYmsBsu) {
                    objEdit["Yms_BookingSuppliers"] = resYmsBsu;
                }
                const resYmsPor = await getPorders(serverUrl, props.userToken, allColumnsObj, objEdit.Obj.BookingId);
                if (resYmsPor) {
                    objEdit["Yms_Porders"] = resYmsPor;
                }
                const resYmsSup = await getSuppliers(serverUrl, props.userToken, allColumnsObj, objEdit.Obj.BookingId);
                if (resYmsSup) {
                    objEdit["Yms_Suppliers"] = resYmsSup;
                }

                if (app.sessionToken?.SupplierId && props.actions === "NewBoocking" && !resYmsBsu?.length) {
                    const supplierObjectName = "Yms_Suppliers";
                    let supDefaultVariables = {
                        "filterName": "customfilter",
                    };
                    let supPrms = [];
                    let supPrmValues = {};
                    supDefaultVariables["appendFilter"] = "{YmsSup.SupplierId} = ?(;n;15;p_SupplierId)";
                    supPrms.push({ "parameterName": "p_SupplierId", "type": "" });
                    supPrmValues["p_SupplierId"] = app.sessionToken?.SupplierId;

                    const userSupplierData = await loadDataObject(serverUrl, props.userToken, supplierObjectName, allColumnsObj, supPrms, supPrmValues, supDefaultVariables);

                    if (userSupplierData && userSupplierData.length > 0) {
                        objEdit["Yms_Suppliers"] = userSupplierData;

                        const bookingSupObjectName = "Yms_BookingSuppliers";
                        let bsPrms = [];
                        let bsPrmValues = {};
                        const parentSelectedRow = objEdit.Obj;
                        let bsDefaultVariables = {
                            "instanceName": "m_yms_booking",
                            "dontCash": "true",
                            "createNewRow": "true",
                            "parentSelectedRow": parentSelectedRow
                        };

                        const bsResult = await loadEditObject(serverUrl, props.userToken, allColumnsObj[bookingSupObjectName], bsPrms, bsPrmValues, bsDefaultVariables);
                        if (bsResult.data[bookingSupObjectName]) {
                            let suprow = bsResult.data[bookingSupObjectName][0];
                            suprow.SupplierId = userSupplierData[0].SupplierId;
                            suprow.SupplierCode = userSupplierData[0].SupplierCode;
                            suprow.YmsSup1.Name1 = userSupplierData[0].Name1;
                            suprow.YmsSup1.SocialSecurityNo = userSupplierData[0].SocialSecurityNo;

                            objEdit["Yms_BookingSuppliers"] = [suprow];
                        }
                    }
                }
                const YmsBta = await getBookingTasks(serverUrl, props.userToken, allColumnsObj, objEdit.Obj.BookingId);
                if (YmsBta) {
                    objEdit["Yms_BookingTasks"] = YmsBta;
                }

                // Load 3PL data if exists
                if (objEdit.Obj.Yms3plId && props.actions !== "NewBoocking") {
                    const threePlObjectName = "Yms_3pls";
                    let threePlDefaultVariables = {
                        "filterName": "customfilter",
                    };
                    let threePlPrms = [];
                    let threePlPrmValues = {};
                    threePlDefaultVariables["appendFilter"] = "{Yms3pl.Yms3plId} = ?(;n;15;p_Yms3plId)";
                    threePlPrms.push({ "parameterName": "p_Yms3plId", "type": "" });
                    threePlPrmValues["p_Yms3plId"] = objEdit.Obj.Yms3plId;

                    const threePlData = await loadDataObject(serverUrl, props.userToken, threePlObjectName, allColumnsObj, threePlPrms, threePlPrmValues, threePlDefaultVariables);

                    if (threePlData && threePlData.length > 0) {
                        objEdit["Yms_3pls"] = threePlData;
                    }
                }

                setBookingObj(objEdit)
            }
        }
        getYmsBooking();
    }, [allColumnsObj, serverUrl, userid, props.warehouseid, props.actions, props.selectTtimeSlot, app.sessionToken, props.userToken, props?.bookingId, User3plId]);

    const [savedPos, setSavedPos] = useState([]);
    const handleOpenModal = () => {
        setSavedPos([...(bookingObj["Yms_Porders"] || [])]);
        setIsModalOpen(true);
    };
    const handleCloseModal = () => {
        setBookingObj(prev => ({
            ...prev,
            Yms_Porders: [...savedPos]
        }));
        setIsModalOpen(false);
    };

    async function addTask() {
        const objectName = "Yms_BookingTasks";
        let prms = [];
        let prmValues = {};
        const parentSelectedRow = bookingObj.Obj;
        let defaultVariables = {
            "instanceName": "m_yms_booking",
            "dontCash": "true"
        }
        defaultVariables["createNewRow"] = "true";
        defaultVariables["parentSelectedRow"] = parentSelectedRow;
        const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables)
        if (result.data[objectName]) {

            setBookingObj(prev => {
                prev = { ...prev }
                if (!prev[objectName]) prev[objectName] = [];
                else prev[objectName] = [...prev[objectName]];
                prev[objectName].push(result.data[objectName][0]);
                return prev;
            });
            // Auto-open the newly added task in accordion
            const newTaskIndex = bookingObj[objectName]?.length || 0;
            setActiveAccordionKey(newTaskIndex.toString());
        }
    };
    const deleteTask = (rowIndex) => {
        let tmpbookingObj = { ...bookingObj }
        tmpbookingObj["Yms_BookingTasks"].splice(rowIndex, 1)
        setBookingObj(tmpbookingObj);
    };
    async function handleSaveBooking() {
        const hasEmptyCategory = bookingObj["Yms_BookingTasks"]?.some(task =>
            !task.YmsCat1?.Descr1 || task.YmsCat1.Descr1.trim() === ''
        );

        if (hasEmptyCategory) {
            setErrorMessage(t('ModalBooking.categoryRequired', language));
            console.warn('Cannot save booking: Some tasks have empty item categories.');
            return;
        }

        const saveobj = await postBooking(serverUrl, props.userToken, "Yms_Booking", "m_yms_booking", bookingObj);
        if (saveobj) {
            setIsBookingSaved(true);
            // if (role === "Admin" && props.actions === "NewBoocking") {
            //     props.handContextMenu("Accepted", bookingObj.Obj?.BookingId);
            // }
            let tmpMsgError = null
            if (saveobj?.ErrorMessage) {
                tmpMsgError = "ArrivalId:" + saveobj?.ArrivalId + ", " + saveobj?.ErrorMessage
            }
            setTimeout(() => {
                props.handlePrev();
                props.handleCloseModalOuter();
            }, 1700);
            props.handContextMenu("Save", 0, null, tmpMsgError);
        }
    };


    async function handleSavePos() {
        const poUpdated = { ...bookingObj };
        const objectName = "Yms_BookingSuppliers";
        const poorders = [...(poUpdated["Yms_Porders"] || [])];
        const bookingSuppliers = [...(poUpdated[objectName] || [])];

        const availableSuppliers = bookingSuppliers.filter(
            bs => !poorders.some(po => po.PoId === bs.PoId)
        );
        if (availableSuppliers) {
            for (let index = 0; index < availableSuppliers.length; index++) {
                const indsup = bookingSuppliers.findIndex(e => e.PoId === availableSuppliers[index].PoId);
                if (indsup > -1) {
                    bookingSuppliers.splice(indsup, 1);
                }
            }
        }
        for (let index = 0; index < poorders.length; index++) {
            const indsup = bookingSuppliers.findIndex(e => e.PoId === poorders[index].PoId)
            if (indsup > -1) { continue; }
            let prms = [];
            let prmValues = {};
            const parentSelectedRow = bookingObj.Obj;
            let defaultVariables = {
                "instanceName": "m_yms_booking",
                "dontCash": "true"
            }
            defaultVariables["createNewRow"] = "true";
            defaultVariables["parentSelectedRow"] = parentSelectedRow;
            const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables)
            if (result.data[objectName]) {

                let suprow = result.data[objectName][0];
                suprow.PoId = poorders[index].PoId;
                suprow.SupplierId = poorders[index].SupplierId;
                suprow.YmsSup1.Name1 = poorders[index].YmsSup1.Name1;
                suprow.YmsPor1.PoCode = poorders[index].PoCode;
                bookingSuppliers.push(suprow);
            }
        }
        poUpdated[objectName] = bookingSuppliers;
        setBookingObj(poUpdated);
        if (poorders && poorders.length > 0) {
            setSelectionMethod('pos');
            setBookingObj(prev => ({
                ...prev
            }));
        }
        setIsModalOpen(false);
    }
    function onSelectedPos() {
        const strPo = bookingObj["Yms_Porders"]?.map(rowPo => rowPo.PoCode)
            .filter(code => code != null)
            .join(', ');
        return strPo;
    }
    function descrSupplier() {
        const names = bookingObj["Yms_BookingSuppliers"]
            ?.map(row => row.YmsSup1?.Name1)
            .filter(name => name != null);
        const uniqueNames = [...new Set(names)];

        return uniqueNames.join(', ');
    }

    const handleSelectPo = (rowPo) => {
        setBookingObj(prev => {
            const poUpdated = { ...prev };
            const poorders = [...(poUpdated["Yms_Porders"] || [])];
            const index = poorders.findIndex(e => e.PoId === rowPo.PoId);
            if (index > -1) {
                poorders.splice(index, 1);
            } else {
                poorders.push(rowPo);
            }
            poUpdated["Yms_Porders"] = poorders;
            setSelectionMethod('pos');
            return poUpdated;
        });
    }
    function findSelectPo(rowPo) {
        return bookingObj["Yms_Porders"]?.find(e => e.PoId === rowPo.PoId)
    };


    async function handleSaveSuppliers() {

        const supUpdated = { ...bookingObj };
        const objectName = "Yms_BookingSuppliers";
        const suppliers = [...(supUpdated["Yms_Suppliers"] || [])];
        const bookingSuppliers = [...(supUpdated[objectName] || [])];

        if (role !== "3pls" && role !== "Admin") {
            if (suppliers.length > 1) {
                setErrorMessage(t('ModalBooking.selectOnlyOneSupplier', language));
                return;
            }
        }
        setErrorMessage(null);

        const availableSuppliers = bookingSuppliers.filter(
            bs => !suppliers.some(sup => sup.SupplierId === bs.SupplierId)
        );
        if (availableSuppliers) {
            for (let index = 0; index < availableSuppliers.length; index++) {
                const indsup = bookingSuppliers.findIndex(e => e.SupplierId === availableSuppliers[index].SupplierId);
                if (indsup > -1) {
                    bookingSuppliers.splice(indsup, 1);
                }
            }
        }
        for (let index = 0; index < suppliers.length; index++) {
            const indsup = bookingSuppliers.findIndex(e => e.SupplierId === suppliers[index].SupplierId)
            if (indsup > -1) { continue; }
            let prms = [];
            let prmValues = {};
            const parentSelectedRow = bookingObj.Obj;
            let defaultVariables = {
                "instanceName": "m_yms_booking",
                "dontCash": "true"
            }
            defaultVariables["createNewRow"] = "true";
            defaultVariables["parentSelectedRow"] = parentSelectedRow;
            const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables)
            if (result.data[objectName]) {

                let suprow = result.data[objectName][0];
                suprow.SupplierId = suppliers[index].SupplierId;
                suprow.SupplierCode = suppliers[index].SupplierCode;
                suprow.YmsSup1.Name1 = suppliers[index].Name1;
                suprow.YmsSup1.SocialSecurityNo = suppliers[index].SocialSecurityNo;
                bookingSuppliers.push(suprow);
            }
        }
        supUpdated[objectName] = bookingSuppliers;
        setBookingObj(supUpdated);
        if (suppliers && suppliers.length > 0) {
            setSelectionMethod('suppliers');
            setBookingObj(prev => ({
                ...prev,
                Yms_Porders: []
            }));
        }
        setIsModalOpen(false);
        setIsSuppliersModalOpen(false);
    }
    function onSelectedSup() {
        const strSup = bookingObj["Yms_Suppliers"]?.map(rowSup => rowSup.SupplierCode)
            .filter(code => code !== null)
            .join(', ');
        return strSup;
    }
    const handleSelectSupplier = (supplier) => {
        setBookingObj(prev => {
            const updated = { ...prev };
            const suppliers = [...(updated["Yms_Suppliers"] || [])];

            const index = suppliers.findIndex(s => s.SupplierId === supplier.SupplierId);

            if (role === "3pls" || role === "Admin") {
                if (index > -1) {
                    suppliers.splice(index, 1);
                } else {
                    suppliers.push(supplier);
                }
                updated["Yms_Suppliers"] = suppliers;
            } else {
                if (index > -1) {
                    updated["Yms_Suppliers"] = [];
                } else {
                    updated["Yms_Suppliers"] = [supplier];
                }
            }

            setSelectionMethod('suppliers');
            return updated;
        });
    };

    const findSelectSupplier = (supplier) => {
        return bookingObj["Yms_Suppliers"]?.some(s => s.SupplierId === supplier.SupplierId);
    };

    const handleSelect3pl = (threePl) => {
        setBookingObj(prev => {
            const updated = { ...prev };
            const threePls = [...(updated["Yms_3pls"] || [])];
            const index = threePls.findIndex(t => t.Yms3plId === threePl.Yms3plId);

            if (index > -1) {
                updated["Yms_3pls"] = [];
            } else {
                updated["Yms_3pls"] = [threePl];
            }

            return updated;
        });
    };

    const findSelect3pl = (threePl) => {
        return bookingObj["Yms_3pls"]?.some(t => t.Yms3plId === threePl.Yms3plId);
    };

    async function handleSave3pls() {
        const threePlUpdated = { ...bookingObj };
        const threePls = [...(threePlUpdated["Yms_3pls"] || [])];

        if (threePls.length > 0) {
            threePlUpdated.Obj.Yms3plId = threePls[0].Yms3plId;
            threePlUpdated.Obj.Yms3pl1 = {
                SocialSecurityNo: threePls[0].SocialSecurityNo,
                Descr1: threePls[0].Descr1
            };
        }

        setBookingObj(threePlUpdated);
        setIs3plsModalOpen(false);
    }

    function onSelected3pl() {
        // First check if there's a selected 3PL in the array (from modal selection)
        if (bookingObj["Yms_3pls"]?.length > 0) {
            return bookingObj["Yms_3pls"].map(row3pl => row3pl.Descr1).join(', ');
        }
        // Otherwise show the existing 3PL from the booking object
        if (bookingObj?.Obj?.Yms3pl1?.Descr1) {
            return bookingObj.Obj.Yms3pl1.Descr1;
        }
        return '';
    }



    async function setObjectValue(objName, rowIndex, column, value, selectedIndex) {
        let obj = {};
        if (rowIndex === null) {
            obj = { ...bookingObj["Obj"] };
        }
        else {
            obj = { ...bookingObj[objName][rowIndex] };
        }
        let tmpObj = { ...obj };
        setPropValue(tmpObj, column.columnName, value);
        if (selectedIndex >= 0 && lookUpInfo[objName][column.columnName] && lookUpInfo[objName][column.columnName].keyFields) {
            for (let i = 0; i < lookUpInfo[objName][column.columnName].keyFields.length; i++) {
                let kf = lookUpInfo[objName][column.columnName].keyFields[i];
                if (selectedIndex === 0) {
                    tmpObj[kf.foreignField] = null;
                }
                else {
                    tmpObj[kf.foreignField] = lookUpInfo[objName][column.columnName].values[selectedIndex - 1][kf.primaryField];
                }
            };
        }
        let tmpbookingObj = { ...bookingObj }
        if (rowIndex === null) {
            tmpbookingObj["Obj"] = tmpObj;
        }
        if (column.columnName === "YmsTrk1.LicenseNo") {
            tmpbookingObj["Obj"].YmsTrk1.LicenseNo = value.lkpField;
            tmpbookingObj["Obj"].TruckId = value.pkField;
            tmpbookingObj["Obj"].YmsTrk1.Descr1 = value.secondaryField;
        }
        if (column.columnName === "YmsDri1.Name1") {
            tmpbookingObj["Obj"].YmsDri1.DriverCode = value.secondaryField;
            tmpbookingObj["Obj"].DriverId = value.pkField;
            tmpbookingObj["Obj"].YmsDri1.Name1 = value.lkpField;
        }
        else {
            if (!tmpbookingObj[objName]) {
                tmpbookingObj[objName] = [];
            }
            tmpbookingObj[objName][rowIndex] = tmpObj;
        }
        setBookingObj(tmpbookingObj);
    }

    function createTextBox(obj, columnName, objName, rowIndex) {
        const column = allColumnsObj[objName].columns.find(c => c.columnName === columnName);
        let colValue = getPropValue(obj, column.columnName)
        return <Form.Control
            /*placeholder={column.caption}*/
            value={colValue}
            onChange={e => setObjectValue(objName, rowIndex, column, e.target.value)}
            readOnly={column.editNotAllowed === true}
        // disabled={disabledCols[column.columnName]}
        //  onBlur={e => fieldLostFocus(column, e.target.value)}
        />;

    }

    function createTextBoxCommends(obj, columnName, objName, rowIndex) {
        if (!allColumnsObj[objName] || !allColumnsObj[objName].columns) {
            return <Form.Control as="textarea" rows={2} readOnly />;
        }

        const column = allColumnsObj[objName].columns.find(c => c.columnName === columnName);
        if (!column) {
            return <Form.Control as="textarea" rows={2} readOnly />;
        }

        let colValue = getPropValue(obj, column.columnName);
        return <Form.Control
            as="textarea"
            rows={2}
            value={colValue}
            onChange={e => setObjectValue(objName, rowIndex, column, e.target.value)}
            readOnly={column.editNotAllowed === true}
        />;
    }

    function createDropDownLookUpList(obj, columnName, objName, rowIndex) {
        if (!lookUpInfo[objName] || !lookUpInfo[objName][columnName]) return null;
        let column = lookUpInfo[objName][columnName].column;

        // Prepare options for CustomDropdown
        const options = lookUpInfo[objName][column.columnName].values.map(lkpObj => ({
            value: lkpObj[column.dropDownDisplay],
            label: lkpObj[column.dropDownDisplay]
        }));

        return (
            <CustomDropdown
                options={options}
                value={getPropValue(obj, column.columnName)}
                onChange={(e) => setObjectValue(objName, rowIndex, column, e.target.value, e.target.selectedIndex)}
                readonly={column.editNotAllowed === true}
                showEmptyOption={true}
                placeholder={`${t('common.selectOne', language)}...`}
            />
        );
    }
    function createDropDownEnumList(obj, columnName, objName, rowIndex) {
        const column = allColumnsObj[objName].columns.find(c => c.columnName === columnName);

        const options = column.controlOptions.map(enm => ({
            value: enm.value,
            label: enm.text
        }));

        return (
            <CustomDropdown
                options={options}
                value={getPropValue(obj, column.columnName)}
                onChange={(e) => setObjectValue(objName, rowIndex, column, e.target.value)}
                readonly={column.editNotAllowed === true}
                showEmptyOption={false}
                placeholder={`${t('common.selectOne', language)}...`}
            />
        );
    }
    function formatDateValue(colValue, format) {
        if (!colValue) return colValue;
        let retVal = colValue;

        //let d = parse(colValue, "dd/MM/yyyy HH:mm", new Date())
        let d = Date(colValue);
        if (!(d instanceof Date) || isNaN(d)) {
            if (retVal.toString().length >= 13) {
                d = new Date(retVal);
            }
            else {
                d = parse(colValue,
                    (format === 'dt') ? "dd/MM/yyyy HH:mm" : (format === 't') ? "HH:mm" : "dd/MM/yyyy",
                    new Date());
            }
        }
        if ((d instanceof Date)) {
            if (format === 'd') {
                return d.getDate().toString().padStart(2, '0') + "/" +
                    (d.getMonth() + 1).toString().padStart(2, '0') + "/" +
                    d.getFullYear();
            }
            else if (format === 't') {
                return d.getHours().toString().padStart(2, '0') + ":" +
                    d.getMinutes().toString().padStart(2, '0');
            }
            else if (format === 'dt') {
                return d.getDate().toString().padStart(2, '0') + "/" +
                    (d.getMonth() + 1).toString().padStart(2, '0') + "/" +
                    d.getFullYear() + " " +
                    d.getHours().toString().padStart(2, '0') + ":" +
                    d.getMinutes().toString().padStart(2, '0');
            }
        }
        return retVal;
    }
    function CreatDatetime(obj, columnName, objName, rowIndex) {
        const column = allColumnsObj[objName].columns.find(c => c.columnName === columnName);
        let pickerType = (column.format === 'dt') ? "DateTime" : (column.format === 't') ? "Time" : "Date";
        let format = (column.format === 'dt') ? "dd/MM/yyyy HH:mm" : (column.format === 't') ? "HH:mm" : "dd/MM/yyyy";
        return <DynamicDatePicker
            caption=""
            pickerType={pickerType}
            dateFormat={format}
            value={formatDateValue(getPropValue(obj, column.columnName), column.format)}
            onChange={(value) => setObjectValue(objName, rowIndex, column, value)}
            readOnly={column.editNotAllowed === true}
            locale={language}
            disabled={!(role === "Admin" || role === "Planner")}
        //  disabled={disabledCols[column.columnName]}
        />;
    }
    function createAutoCompleteGeneric({
        objName,
        rowIndex,
        disabledFieldsFlg,
        columnConfig,
        objectName,
        instanceName,
        lookupPrimaryField,
        lookupSecondaryField,
        setFieldsInBookingObj
    }) {
        const obj = rowIndex === null
            ? bookingObj["Obj"]
            : bookingObj[objName][rowIndex];

        const primaryVal = getPropValue(obj, columnConfig.columnName) || "";
        const secondaryVal = getPropValue(obj, columnConfig.secondaryField) || "";

        return (
            <AutoCompleteOneOutPut
                key={`${primaryVal}_${secondaryVal}`}
                as="AutoComplete"
                placeholder=""
                serverUrl={serverUrl}
                props={props}
                col={columnConfig}
                obj={{
                    ...obj,
                    [columnConfig.columnName]: primaryVal,
                    [columnConfig.secondaryField]: secondaryVal,
                }}
                onChange={async (e) => {
                    if (e && e?.option?.secondaryField === '') {
                        let prms = [];
                        let prmValues = {};
                        const parentSelectedRow = bookingObj.Obj;
                        let defaultVariables = {
                            instanceName: instanceName,
                            dontCash: "true",
                            createNewRow: "true",
                            parentSelectedRow: parentSelectedRow
                        };

                        const result = await loadEditObject(serverUrl, props.userToken, allColumnsObj[objectName], prms, prmValues, defaultVariables);
                        const rawData = result?.data?.[objectName]?.[0] || {};
                        let tmprawData = { ...rawData };
                        if (columnConfig.columnName === 'YmsDri1.Name1') {
                            tmprawData[lookupPrimaryField] = e?.option.lkpField;
                            tmprawData.ActiveFlg = true;
                            tmprawData[lookupSecondaryField] = tmprawData.DriverId;
                        } else {
                            tmprawData[lookupPrimaryField] = e?.option.lkpField;
                            tmprawData.ActiveFlg = true;
                            tmprawData[lookupSecondaryField] = `Εκκρεμής ${columnConfig.descr}`;
                        }

                        const gqlCols = createGql("", allColumnsObj[objectName].columns, []);
                        const requestBody = {
                            query: `mutation save${objectName}($obj: ${objectName}!){` +
                                `save${objectName}(${objectName}: $obj) ${gqlCols.query} }`,
                            variables: {
                                obj: {
                                    instanceName: '',
                                    filterName: "default",
                                    top: gridTop,
                                    changedData: [
                                        {
                                            action: "insert",
                                            original: null,
                                            current: tmprawData
                                        }
                                    ]
                                }
                            }
                        };
                        const gqlResult = await callApi('POST', `${serverUrl}/api/query`, props.userToken, requestBody);
                        const newEntry = gqlResult.data[objectName][0];

                        let tmpbookingObj = { ...bookingObj };
                        setFieldsInBookingObj(tmpbookingObj, newEntry);
                        setBookingObj(tmpbookingObj);
                        return;
                    }

                    setObjectValue(objName, rowIndex, columnConfig, e ? e.option : "");
                }}
                disabled={disabledFieldsFlg}
            />
        );
    }

    if (!isLoadObj) return;
    if (!bookingObj || (Object.keys(bookingObj).length === 0)) return;
    return (

        <div className="creation-form">
            {isBookingSaved ? (
                <div className="booking-success-message">
                    <img src={app.theme === 'dark' ? "./images/Tablet-Succ-Screen-Dark.png" : "./images/Tablet-Succ-Screen.png"} alt="success" />
                    <div>
                        <p>{(t('ModalBooking.successTitleForBooking', language))}</p>
                        <span className="booking-success-subtitle">{(t('ModalBooking.successSubTitleForBooking', language))}: {getPropValue(bookingObj.Obj, "BookingId")}</span>
                        <span className="booking-success-details">
                            {(t('ModalBooking.successSubTitleDetailsForBooking', language))}
                        </span>
                    </div>
                </div>
            ) : (
                <>
                    <ErrorAlert message={errorMessage} setMessage={setErrorMessage} language={language} />
                    {props.activeTab === 1 && (
                        <>
                            <div className="header-form-new-booking">
                                {/* <i className="bi bi-arrow-left" style={{ marginTop: "1px", cursor: 'pointer' }} onClick={props.handleDisplaySidebar}></i> */}
                                <h2>
                                    {props.actions === "NewBoocking" ?
                                        <><i className="bi bi-plus-lg icon-badge"></i>{t('ModalBooking.createNewBookingTitle', language)} </>
                                        :
                                        <><i className="bi bi-pencil-square icon-badge"></i>{t('ModalBooking.editBookingTitle', language)}</>}
                                </h2>
                            </div>
                            {props.actions !== "NewBoocking" && (
                                <div className="edit-info-banner">
                                    <i className="bi bi-file-earmark-text"></i>
                                    <span>Booking ID: #{getPropValue(bookingObj.Obj, "BookingId")}</span>
                                </div>
                            )}
                            {props.actions === "NewBoocking" && (
                                <div className="stepper-container">
                                    <div className={`step ${props.activeTab === 1 ? 'active' : ''} ${props.activeTab > 1 ? 'completed' : ''}`}>
                                        <div className="step-number">
                                            {props.activeTab > 1 ? <i className="bi bi-check-lg"></i> : '1'}
                                        </div>
                                        <div className="step-label">{t('ModalBooking.stepBasicInfo', language)}</div>
                                        <div className="step-line"></div>
                                    </div>
                                    <div className={`step ${props.activeTab === 2 ? 'active' : ''} ${props.activeTab > 2 ? 'completed' : ''}`}>
                                        <div className="step-number">
                                            {props.activeTab > 2 ? <i className="bi bi-check-lg"></i> : '2'}
                                        </div>
                                        <div className="step-label">{t('ModalBooking.stepActions', language)}</div>
                                    </div>
                                </div>
                            )}
                            <Form>
                                <Form.Group className="mb-3">
                                    <Form.Label className="label-to-left">{(t('ModalBooking.posTitleForm', language))}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={(t('ModalBooking.posPlaceholder', language))}
                                        value={onSelectedPos()}
                                        readOnly
                                        disabled={selectionMethod === 'suppliers' || (selectionMethod !== 'pos' && bookingObj["Yms_Suppliers"]?.length > 0)}
                                        onClick={handleOpenModal}
                                        style={{ cursor: bookingObj["Yms_Suppliers"]?.length > 0 ? "not-allowed" : "pointer", backgroundColor: app.theme === 'dark' ? 'var(--bg-tertiary)' : '#fff', color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}
                                    />
                                </Form.Group>

                                <Form.Group className="mb-3">
                                    <Form.Label className="label-to-left">{(t('ModalBooking.supplierTitleForm', language))}</Form.Label>
                                    <Form.Control
                                        type="text"
                                        placeholder={(t('ModalBooking.supplierPlaceholder', language))}
                                        value={onSelectedSup()}
                                        readOnly
                                        disabled={selectionMethod === 'pos' || (selectionMethod !== 'suppliers' && bookingObj["Yms_Porders"]?.length > 0)}
                                        onClick={handleOpenSuppliersModal}
                                        style={{ cursor: bookingObj["Yms_Porders"]?.length > 0 ? "not-allowed" : "pointer", backgroundColor: app.theme === 'dark' ? 'var(--bg-tertiary)' : '#fff', color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}
                                    />
                                </Form.Group>
                                {(role === "Admin" || role === "Planner") && (
                                    <Form.Group className="mb-3">
                                        <Form.Label className="label-to-left">3PL</Form.Label>
                                        <Form.Control
                                            type="text"
                                            placeholder={(t('ModalBooking.plPlaceholder', language))}
                                            value={onSelected3pl()}
                                            readOnly
                                            onClick={handleOpen3plsModal}
                                            style={{ cursor: "pointer", backgroundColor: app.theme === 'dark' ? 'var(--bg-tertiary)' : '#fff', color: app.theme === 'dark' ? 'var(--text-secondary)' : 'inherit' }}
                                        />
                                    </Form.Group>
                                )}
                                <Form.Group className="mb-3">
                                    <Form.Label className="label-to-left">{(t('ModalBooking.descrSupplierTitleForm', language))}</Form.Label>
                                    <div style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '8px',
                                        flexWrap: 'wrap',
                                        minHeight: '35px'
                                    }}>
                                        {descrSupplier() ? (
                                            descrSupplier().split(', ').map((name, idx) => (
                                                <span key={idx} style={{
                                                    backgroundColor: 'var(--color-main-background)',
                                                    color: 'white',
                                                    padding: '6px 12px',
                                                    borderRadius: '22px',
                                                    fontSize: '14px',
                                                    fontWeight: '500',
                                                    display: 'inline-block'
                                                }}>
                                                    {name}
                                                </span>
                                            ))
                                        ) : (
                                            <span style={{
                                                backgroundColor: 'var(--bg-secondary)',
                                                border: '2px dashed var(--border-color)',
                                                color: 'var(--text-secondary)',
                                                padding: '6px 12px',
                                                borderRadius: '22px',
                                                fontSize: '13px',
                                                fontWeight: '500',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                gap: '6px'
                                            }}>
                                                <i className="bi bi-info-circle"></i>
                                                {t('ModalBooking.autoFilledField', language)}
                                            </span>
                                        )}
                                    </div>
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label className="label-to-left">{(t('ModalBooking.dateTimeTitleForm', language))}<span className='required-bullet'>*</span></Form.Label>
                                    {CreatDatetime(bookingObj.Obj, "FromDate", "Yms_Booking", null)}
                                </Form.Group>
                                <Row>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="label-to-left">{(t('ModalBooking.driverTitleForm', language))}</Form.Label>
                                            {createAutoCompleteGeneric({
                                                objName: "Yms_Booking",
                                                rowIndex: null,
                                                disabledFieldsFlg: props.disabledFieldsFlg,
                                                columnConfig: {
                                                    descr: "οδηγό",
                                                    columnName: "YmsDri1.Name1",
                                                    dropDownDisplay: "Name1",
                                                    lookUpQuery: "{Yms_Drivers{DriverId Name1 DriverCode}}",
                                                    secondaryField: "YmsDri1.DriverCode"
                                                },
                                                objectName: "Yms_Drivers",
                                                instanceName: "m_yms_drivers",
                                                lookupPrimaryField: "Name1",
                                                lookupSecondaryField: "DriverCode",
                                                setFieldsInBookingObj: (tmpObj, newEntry) => {
                                                    tmpObj["Obj"].YmsDri1.Name1 = newEntry.Name1;
                                                    tmpObj["Obj"].DriverId = newEntry.DriverId;
                                                    tmpObj["Obj"].YmsDri1.DriverCode = newEntry.DriverCode;
                                                }
                                            })
                                            }
                                        </Form.Group>
                                    </Col>
                                    <Col>
                                        <Form.Group className="mb-3">
                                            <Form.Label className="label-to-left">{(t('ModalBooking.licenseNoTitleForm', language))}</Form.Label>

                                            {createAutoCompleteGeneric({
                                                objName: "Yms_Booking",
                                                rowIndex: null,
                                                disabledFieldsFlg: props.disabledFieldsFlg,
                                                columnConfig: {
                                                    descr: "πινακίδα",
                                                    columnName: "YmsTrk1.LicenseNo",
                                                    dropDownDisplay: "LicenseNo",
                                                    lookUpQuery: "{Yms_Trucks{TruckId LicenseNo Descr1}}",
                                                    secondaryField: "YmsTrk1.Descr1"
                                                },
                                                objectName: "Yms_Trucks",
                                                instanceName: "m_yms_trucks",
                                                lookupPrimaryField: "LicenseNo",
                                                lookupSecondaryField: "Descr1",
                                                setFieldsInBookingObj: (tmpObj, newEntry) => {
                                                    tmpObj["Obj"].YmsTrk1.LicenseNo = newEntry.LicenseNo;
                                                    tmpObj["Obj"].TruckId = newEntry.TruckId;
                                                    tmpObj["Obj"].YmsTrk1.Descr1 = newEntry.Descr1;
                                                }
                                            })}

                                        </Form.Group>
                                    </Col>
                                </Row>
                                <Form.Group className="mb-3">
                                    <Form.Label className="label-to-left">{t("entryWithBooking.commentTitleForm", language)}</Form.Label>
                                    {createTextBoxCommends(bookingObj.Obj, "Notes", "Yms_Booking", null)}
                                </Form.Group>
                                <Form.Group className="mb-3">
                                    <Form.Label className="label-to-left">{(t('ModalBooking.phoneTitleForm', language))}</Form.Label>
                                    {createTextBox(bookingObj.Obj, "Phone", "Yms_Booking", null)}
                                </Form.Group>
                                <div className='next-new-event-in-calendar'>
                                    <Button onClick={async () => {
                                        if (
                                            props.actions === "NewBoocking" &&
                                            (
                                                !bookingObj["Yms_BookingTasks"] ||
                                                (bookingObj["Yms_BookingTasks"].length === 0 && bookingObj["Yms_BookingTasks"].length < 1)
                                            )
                                        ) {
                                            await addTask();
                                            setActiveAccordionKey("0");
                                        }

                                        props.handleNext();
                                    }}>
                                        {(t('common.next', language))} <i className="bi bi-arrow-right" style={{ marginTop: "1px", marginLeft: "3px" }}></i>
                                    </Button>
                                </div>
                            </Form>
                        </>
                    )}

                    {props.activeTab === 2 && (
                        <>
                            <div className="header-form-new-booking">
                                <h2><i className="bi bi-list-task icon-badge"></i>{(t('ModalBooking.descrForBookingTitle', language))}</h2>
                            </div>
                            {props.actions !== "NewBoocking" && (
                                <div className="edit-info-banner">
                                    <i className="bi bi-file-earmark-text"></i>
                                    <span>Booking ID: #{getPropValue(bookingObj.Obj, "BookingId")}</span>
                                </div>
                            )}
                            {props.actions === "NewBoocking" && (
                                <div className="stepper-container">
                                    <div className={`step ${props.activeTab === 1 ? 'active' : ''} ${props.activeTab > 1 ? 'completed' : ''}`}>
                                        <div className="step-number">
                                            {props.activeTab > 1 ? <i className="bi bi-check-lg"></i> : '1'}
                                        </div>
                                        <div className="step-label">{t('ModalBooking.stepBasicInfo', language)}</div>
                                        <div className="step-line"></div>
                                    </div>
                                    <div className={`step ${props.activeTab === 2 ? 'active' : ''} ${props.activeTab > 2 ? 'completed' : ''}`}>
                                        <div className="step-number">
                                            {props.activeTab > 2 ? <i className="bi bi-check-lg"></i> : '2'}
                                        </div>
                                        <div className="step-label">{t('ModalBooking.stepActions', language)}</div>
                                    </div>
                                </div>
                            )}
                            <Accordion
                                activeKey={activeAccordionKey}
                                onSelect={(eventKey) => setActiveAccordionKey(eventKey)}
                            >
                                {bookingObj["Yms_BookingTasks"]?.map((task, index) => (
                                    <Accordion.Item eventKey={index.toString()} key={task.BookingTaskId}>
                                        <Accordion.Header className='custom-change-for-accordion'>
                                            <div className="accordion-header-content">
                                                <span>
                                                    <strong>{t('ModalBooking.actionsHeader', language)}: </strong>
                                                    {
                                                        task?.YmsTas1?.Descr1 || task?.YmsCat1?.Descr1 || task?.CountOfItems || task?.Pallets
                                                            ? [
                                                                task?.YmsTas1?.Descr1,
                                                                task?.YmsCat1?.Descr1,
                                                                task?.CountOfItems ? `${t('ModalBooking.itemCountTitleForm', language)}(${task.CountOfItems})` : null,
                                                                task?.Pallets ? `${t('ModalBooking.palletCountTitleForm', language)}(${task.Pallets})` : null
                                                            ].filter(Boolean).join(', ')
                                                            : t('ModalBooking.newTaskLabel', language)
                                                    }</span>

                                                <span className="delete-icon" onClick={(e) => { e.stopPropagation(); deleteTask(index); }}>
                                                    <i className="bi bi-ban"></i>
                                                </span>
                                            </div>
                                        </Accordion.Header>
                                        <Accordion.Body>
                                            <Form>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="label-to-left">{t('ModalBooking.actionsHeader', language)}</Form.Label>
                                                    {createDropDownLookUpList(task, "YmsTas1.Descr1", "Yms_BookingTasks", index)}
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="label-to-left" >{t('ModalBooking.categoryTitleForm', language)}</Form.Label>
                                                    {createDropDownLookUpList(task, "YmsCat1.Descr1", "Yms_BookingTasks", index)}
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="label-to-left">{t('ModalBooking.cargoTypeTitleForm', language)}</Form.Label>
                                                    {createDropDownEnumList(task, "CargoType", "Yms_BookingTasks", index)}
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="label-to-left">{t('ModalBooking.itemCountTitleForm', language)}</Form.Label>
                                                    {createTextBox(task, "CountOfItems", "Yms_BookingTasks", index)}
                                                </Form.Group>
                                                <Form.Group className="mb-3">
                                                    <Form.Label className="label-to-left">{t('ModalBooking.palletCountTitleForm', language)}</Form.Label>
                                                    {createTextBox(task, "Pallets", "Yms_BookingTasks", index)}
                                                </Form.Group>
                                            </Form>
                                        </Accordion.Body>
                                    </Accordion.Item>
                                ))}

                                <Button className='button-add-task' onClick={addTask}>
                                    <i className="bi bi-plus-circle"></i> {t('ModalBooking.addTaskButton', language)}
                                </Button>
                            </Accordion>



                            <div className='next-new-event-in-calendar'>
                                <Button
                                    onClick={handleSaveBooking}
                                    disabled={
                                        !bookingObj["Yms_BookingTasks"] ||
                                        bookingObj["Yms_BookingTasks"].length === 0 ||
                                        !bookingObj["Yms_BookingTasks"].some(task =>
                                            task.YmsCat1?.Descr1 || task.YmsTas1?.Descr1
                                        )
                                    }
                                >

                                    {t('common.saveButton', language)} <i className="bi bi-save" style={{ marginLeft: "5px" }} ></i>
                                </Button>
                                <Button onClick={props.handlePrev}>
                                    <i className="bi bi-arrow-left"></i> {t('common.prevButton', language)}
                                </Button>
                            </div>
                        </>
                    )}
                </>)
            }

            <Modal show={isModalOpen} onHide={handleCloseModal} size="xl" centered animation={true} backdrop="static">
                <Modal.Header closeButton className="border-0" />
                <Modal.Body className="text-center modal-pos">
                    <svg className="background-svg" viewBox="0 0 1920 1080" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_2301_81)">
                            <ellipse cx="413.131" cy="422.366" rx="413.131" ry="422.366"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 965.542 1192.45)"
                                fill="var(--color-main-background)" />
                            <ellipse cx="516.414" cy="527.957" rx="516.414" ry="527.957"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 1113.22 1195.26)"
                                fill="var(--color-main-background)" fillOpacity="0.8" />
                            <ellipse cx="650.299" cy="664.835" rx="650.299" ry="664.835"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 1304.66 1198.9)"
                                fill="var(--color-main-background)" fillOpacity="0.8" />
                        </g>
                        <defs>
                            <clipPath id="clip0_2301_81">
                                <rect width="1920" height="1080" fill="white" transform="matrix(-1 0 0 1 1920 0)" />
                            </clipPath>
                        </defs>
                    </svg>

                    <div className="mb-3 position-relative" style={{ zIndex: 1 }}>
                        <img src="./images/pos-photo-list.png" alt="POS List" style={{
                            maxWidth: '200px',
                            width: '100%'
                        }} />
                    </div>
                    <div className="position-relative" style={{ zIndex: 1 }}>
                        <ListPos
                            warehouseid={props.warehouseid}
                            handleSelectPo={handleSelectPo}
                            findSelectPo={findSelectPo}
                            handleSavePos={handleSavePos}
                            userToken={props.userToken}
                            language={language}
                            showModal={isModalOpen}
                        />
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={isSuppliersModalOpen} onHide={handleCloseSuppliersModal} size="xl" centered animation={true} backdrop="static">
                <Modal.Header closeButton className="border-0"></Modal.Header>
                <Modal.Body className="text-center modal-pos">
                    <svg className="background-svg" viewBox="0 0 1920 1080" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_2301_81)">
                            <ellipse cx="413.131" cy="422.366" rx="413.131" ry="422.366"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 965.542 1192.45)"
                                fill="var(--color-main-background)" />
                            <ellipse cx="516.414" cy="527.957" rx="516.414" ry="527.957"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 1113.22 1195.26)"
                                fill="var(--color-main-background)" fillOpacity="0.8" />
                            <ellipse cx="650.299" cy="664.835" rx="650.299" ry="664.835"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 1304.66 1198.9)"
                                fill="var(--color-main-background)" fillOpacity="0.8" />
                        </g>
                        <defs>
                            <clipPath id="clip0_2301_81">
                                <rect width="1920" height="1080" fill="white" transform="matrix(-1 0 0 1 1920 0)" />
                            </clipPath>
                        </defs>
                    </svg>
                    <div style={{ zIndex: 9999 }}>
                        <ErrorAlert message={errorMessage} setMessage={setErrorMessage} language={language} />
                    </div>
                    <div className="mb-3 position-relative" style={{ zIndex: 1 }}>
                        <img src='./images/sup-photo-list.png' alt='Supplier List' style={{
                            maxWidth: '200px',
                            width: '100%'
                        }} />
                    </div>
                    <div className="position-relative" style={{ zIndex: 1 }}>
                        <ListSuppliers
                            handleSelectSupplier={handleSelectSupplier}
                            findSelectSupplier={findSelectSupplier}
                            handleSaveSuppliers={handleSaveSuppliers}
                            userToken={props.userToken}
                            language={language}
                            showModal={isSuppliersModalOpen}
                        />
                    </div>
                </Modal.Body>
            </Modal>

            <Modal show={is3plsModalOpen} onHide={handleClose3plsModal} size="xl" centered animation={true} backdrop="static">
                <Modal.Header closeButton className="border-0"></Modal.Header>
                <Modal.Body className="text-center modal-pos">
                    <svg className="background-svg" viewBox="0 0 1920 1080" xmlns="http://www.w3.org/2000/svg">
                        <g clipPath="url(#clip0_2301_81)">
                            <ellipse cx="413.131" cy="422.366" rx="413.131" ry="422.366"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 965.542 1192.45)"
                                fill="var(--color-main-background)" />
                            <ellipse cx="516.414" cy="527.957" rx="516.414" ry="527.957"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 1113.22 1195.26)"
                                fill="var(--color-main-background)" fillOpacity="0.8" />
                            <ellipse cx="650.299" cy="664.835" rx="650.299" ry="664.835"
                                transform="matrix(-0.685522 -0.728052 -0.728052 0.685522 1304.66 1198.9)"
                                fill="var(--color-main-background)" fillOpacity="0.8" />
                        </g>
                        <defs>
                            <clipPath id="clip0_2301_81">
                                <rect width="1920" height="1080" fill="white" transform="matrix(-1 0 0 1 1920 0)" />
                            </clipPath>
                        </defs>
                    </svg>
                    <div style={{ zIndex: 9999 }}>
                        <ErrorAlert message={errorMessage} setMessage={setErrorMessage} language={language} />
                    </div>
                    <div className="mb-3 position-relative" style={{ zIndex: 1 }}>
                        <img src='./images/3pl-photo-list.png' alt='3PL List'
                            style={{
                                maxWidth: '200px',
                                width: '100%'
                            }} />
                    </div>
                    <div className="position-relative" style={{ zIndex: 1 }}>
                        <List3pls
                            handleSelect3pl={handleSelect3pl}
                            findSelect3pl={findSelect3pl}
                            handleSave3pls={handleSave3pls}
                            userToken={props.userToken}
                            language={language}
                            showModal={is3plsModalOpen}
                        />
                    </div>
                </Modal.Body>
            </Modal>

        </div >

    );
}

export default NewBookingForm;
